export enum MachineFixingType {
  None = -1,
  NoMachineFixing = 0,
  SFixing = 1,
  QCFixing = 2,
}
